import React from 'react';
import { TabType } from '../../types';
import { TABS } from '../../constants';

interface TabNavigationProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

const TabNavigation: React.FC<TabNavigationProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className="flex gap-10 border-b border-brand-grey01 mb-10 overflow-x-auto no-scrollbar no-print">
      {(TABS || []).map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`py-4 text-xs font-bold uppercase tracking-widest transition-all whitespace-nowrap border-b-4 ${
            activeTab === tab.id
              ? 'text-brand-pink border-brand-pink'
              : 'text-brand-grey02 border-transparent hover:text-brand-pink'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;
